import { createIcon } from '@chakra-ui/react';

export const PoliciesOutlineIcon = createIcon({
  displayName: 'PoliciesOutlineIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
      <path
        d="M5.99992 14.6693H9.99992C13.3333 14.6693 14.6666 13.3359 14.6666 10.0026V6.0026C14.6666 2.66927 13.3333 1.33594 9.99992 1.33594H5.99992C2.66659 1.33594 1.33325 2.66927 1.33325 6.0026V10.0026C1.33325 13.3359 2.66659 14.6693 5.99992 14.6693Z"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 6H5.5"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10H5.5"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});
